import { AgentSessionsTable } from "./AgentSessionsTable";

export function SessionsTab() {
  return <AgentSessionsTable />;
}
